export default __webpack_public_path__ + "assets/images/BajajLogo.92c6e922f37076370219e115a31533a1.png";